import SmileAvatarIcon from "../../assets/icons/smile-avatar.svg";
import xCircleIcon from "../../assets/icons/exit-icon.svg";
import { useState } from "react";
import { useStores } from "../../use.store";
import { observer } from "mobx-react-lite";
import { getInformationAsset } from "../../helpers";

const ButtonSmileAvatar = ({ onClick }) => {
  const [isOpen, setIsOpen] = useState(true);
  const { mainStore } = useStores();

  return (
    <div>
      <img
        src={getInformationAsset(
          mainStore.config,
          mainStore.smileFeedbackIcon,
          SmileAvatarIcon
        )}
        onClick={onClick}
        className="absolute bottom-4 left-4 z-10 w-[60px] h-[60px]"
      />
      {isOpen && (
        <div className="absolute bottom-14 left-12 ">
          <div className="bg-[#215732] text-white p-3 rounded-lg shadow-lg max-w-[220px] h-[60px]">
            <p className="text-[12px] pr-6">
              {mainStore.popupMessage ??
                "Hello Visitor! We would really appreciate your feedback!!"}
            </p>
          </div>
          <img
            src={xCircleIcon}
            onClick={() => setIsOpen(false)}
            className="absolute -right-2 z-10 h-[20px] w-[20px]"
            style={{ bottom: "48px", right: "-5px", cursor: "pointer" }}
          />
        </div>
      )}
    </div>
  );
};

export default observer(ButtonSmileAvatar);
